import { CONST } from '../utils/index';

const ROUTES = {
  login: {
    active: true,
    menuItem: false,
    template: 'Login',
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login',
      public: true,
    },
  },
  forbidden: {
    active: true,
    menuItem: false,
    template: 'Forbidden',
    path: '/forbidden',
    name: 'forbidden',
    meta: {
      title: 'Доступ запрещён',
      public: true,
    },
  },
  home: {
    active: true,
    menuItem: true,
    template: 'Dashboards/index',
    path: '/',
    name: 'dashboard',
    redirect: { name: 'dashboardAll' },
    meta: {
      icon: 'dashboard',
      title: 'Dashboard',
    },
    children: {
      dashboardAll: {
        path: '',
        active: true,
        menuItem: false,
        name: 'dashboardAll',
        components: {
          PM: 'Dashboards/PM',
          PLM: 'Dashboards/PLM',
          PO: 'Dashboards/PO',
          LAB: 'Dashboards/LAB',
          MIX: 'Dashboards/MIX',
        },
        meta: {
          title: 'Dashboard',
          requiresAuth: true,
        },
      },
      allTrialsDashboard: {
        path: '/all-trials-dashboard',
        active: true,
        menuItem: true,
        template: 'Dashboards/AllTrialsDashboard',
        name: 'allTrialsDashboard',
        meta: {
          title: 'Все трайлы',
          requiresAuth: true,
        },
      },
    },
  },
  notifications: {
    active: true,
    menuItem: true,
    template: 'Notifications/index',
    path: '/notifications',
    name: 'notificationsIndex',
    meta: {
      icon: 'notifications',
      title: 'Уведомления',
      isNotificationBadge: true,
    },
    children: {}
  },
  booking: {
    active: true,
    menuItem: true,
    template: 'Booking/index',
    name: 'bookingIndex',
    path: '/booking',
    redirect: { name: 'bookingAll' },
    meta: {
      icon: 'speaker_group',
      title: 'Booking',
    },
    children: {
      bookingAll: {
        path: '',
        active: true,
        menuItem: true,
        template: 'Booking/Booking',
        name: 'bookingAll',
        meta: {
          title: 'Booking',
          requiresAuth: true,
        },
      },
      bookAtrial: {
        active: true,
        menuItem: true,
        template: 'Booking/BookAtrial',
        path: 'book-a-trial',
        name: 'bookAtrial',
        meta: {
          title: 'Забронировать трайл',
          parent: 'booking',
          allowedGroups: ['PM'],
        },
      },
      bookingDetail: {
        active: true,
        menuItem: false,
        template: 'Booking/BookingDetail',
        path: ':id',
        name: 'bookingDetail',
        meta: {
          parent: 'booking',
        },
      },
    },
  },
  trial: {
    active: true,
    menuItem: true,
    template: 'Trial/index',
    path: '/trial',
    name: 'trialIndex',
    redirect: { name: 'trialAll' },
    meta: {
      icon: 'speaker_group',
      title: 'Trial',
    },
    children: {
      trialAll: {
        active: true,
        menuItem: true,
        template: 'Trial/Trial',
        path: '',
        name: 'trialAll',
        meta: {
          title: 'Trial',
          parent: 'trial',
        },
      },
      trialNew: {
        active: true,
        menuItem: true,
        template: 'Trial/TrialNew',
        path: 'new-trial',
        name: 'trialNew',
        meta: {
          title: 'Новый трайл',
          parent: 'trial',
          allowedGroups: ['PM'],
        },
      },
      trialDetail: {
        active: true,
        menuItem: true,
        template: 'Trial/TrialDetail/TrialDetail',
        path: '',
        name: 'trialDetail',
        redirect: { name: 'trialGeneral' },
        meta: {
          parent: 'trial',
        },
        children: {
          trialGeneral: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialGeneral',
            path: ':id',
            name: 'trialGeneral',
            meta: {
              parent: 'trial',
              name: 'General',
            },
          },
          trialProcess: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialProcess',
            path: ':id/process',
            name: 'trialProcess',
            meta: {
              parent: 'trial',
              name: 'Process',
              showing_permission: CONST.trial.META.PERMISSIONS.SHOWING_PROCESS_TAB.value,
            },
          },
          trialRecipe: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialRecipe',
            path: ':id/recipe',
            name: 'trialRecipe',
            meta: {
              parent: 'trial',
              name: 'Recipe',
              showing_permission: CONST.trial.META.PERMISSIONS.SHOWING_RECIPE_TAB.value,
            },
          },
          trialMixing: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialMixing',
            path: ':id/mixing',
            name: 'trialMixing',
            meta: {
              parent: 'trial',
              name: 'Mixing',
              showing_permission: CONST.trial.META.PERMISSIONS.SHOWING_MIXING_TAB.value,
            },
          },
          trialAnalysis: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialAnalysis',
            path: ':id/analysis',
            name: 'trialAnalysis',
            meta: {
              parent: 'trial',
              name: 'Analysis',
              showing_permission: CONST.trial.META.PERMISSIONS.SHOWING_ANALYSIS_TAB.value,
            },
          },
          trialSampling: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialSampling',
            path: ':id/sampling',
            name: 'trialSampling',
            meta: {
              parent: 'trial',
              name: 'Sampling',
            },
          },
          trialHistory: {
            active: true,
            menuItem: false,
            template: 'Trial/TrialDetail/TrialHistory',
            path: ':id/history',
            name: 'trialHistory',
            meta: {
              parent: 'trial',
              name: 'History',
            },
          },
        },
      },
    },
  },
  reporting: {
    active: true,
    menuItem: true,
    menuCollapsed: true,
    template: 'Reporting/index',
    path: '/reports',
    name: 'reportsIndex',
    redirect: { name: 'bookingReport' },
    meta: {
      icon: 'data_usage',
      title: 'Отчеты',
      allowedGroups: ['PLM'],
    },
    children: {
      bookingReport: {
        active: true,
        menuItem: true,
        template: 'Reporting/BookingReport',
        path: 'booking_report',
        name: 'bookingReport',
        meta: {
          title: 'Booking Report',
          parent: 'reporting',
        },
      },
      trialReport: {
        active: true,
        menuItem: true,
        template: 'Reporting/TrialReport',
        path: 'trial_report',
        name: 'trialReport',
        meta: {
          title: 'Trial Report',
          parent: 'reporting',
        },
      },
    }
  },
  documents: {
    active: true,
    menuItem: true,
    template: 'Documents/index',
    path: '/documents',
    name: 'documentsIndex',
    meta: {
      icon: 'work',
      title: 'Документы',
    },
    children: {}
  },
  wiki: {
    active: true,
    menuItem: false,
    template: 'Wiki/index',
    path: '/wiki',
    name: 'wikiIndex',
    meta: {
      icon: 'school',
      title: 'Wiki',
    },
    redirect: { name: 'wikiProjects' },
    children: {
      projects: {
        active: true,
        menuItem: false,
        template: 'Wiki/Wiki',
        path: 'projects',
        name: 'wikiProjects',
        meta: {
          title: 'Projects',
          parent: 'wiki',
        },
      },
      trials: {
        active: true,
        menuItem: false,
        template: 'Wiki/Wiki',
        path: 'trials',
        name: 'wikiTrials',
        meta: {
          title: 'Trials',
          parent: 'wiki',
        },
      },
      audits: {
        active: true,
        menuItem: false,
        template: 'Wiki/Wiki',
        path: 'audits',
        name: 'wikiAudits',
        meta: {
          title: 'Audits',
          parent: 'wiki',
        },
      },
      factories: {
        active: true,
        menuItem: false,
        template: 'Wiki/Wiki',
        path: 'factories',
        name: 'wikiFactories',
        meta: {
          title: 'Factories',
          parent: 'wiki',
        },
      },
      deviceGroup: {
        active: true,
        menuItem: false,
        template: 'Wiki/Wiki',
        path: 'device-group',
        name: 'wikiDeviceGroup',
        meta: {
          title: 'Device group',
          parent: 'wiki',
        },
      },
    },
  },
  accessDenied: {
    active: true,
    menuItem: false,
    template: 'AccessDenied',
    path: '/access-denied',
    name: 'accessDenied',
    meta: {
      title: 'Access denied',
      public: true,
    },
  },
};

const filterBy = (object, field) => {
  return Object.values(JSON.parse(JSON.stringify(object)))
    .filter(item => item[field])
    .map(item => {
      if (item.children) {
        item.children = filterBy(item.children, field);
      }
      return item;
    });
};

const routes = filterBy(ROUTES, 'active');
const menuItems = filterBy(routes, 'menuItem');

export {
  routes,
  menuItems,
  ROUTES,
};
